export const PERMS_UI = [
    // {
    //     title: "Admin",
    //     path: ["admin"],
    //     type: "boolean",
    //     description: "Acesso total (use com cuidado)."
    // },

    // Páginas Permitidas
    {
        title: "Páginas Permitidas",
        section: "paginas",
        items: [
            { key: "produtos", label: "Produtos" },
            { key: "estoques", label: "Estoques" },
            { key: "vendas", label: "Vendas" },
            { key: "compras", label: "Distribuições" },
            { key: "solicitacoes_distribuicao", label: "Solicitações Distribuição" },
            { key: "distribuicoes_vendas", label: "Distribuições X Vendas" },
            { key: "pedidos", label: "Pedidos" },
            { key: "pedidos_expedicao", label: "Pedidos Expedição" },
            { key: "arquivos", label: "Arquivos" },
        ],
    },

    // Produtos
    {
        title: "Produtos",
        section: "produtos",
        groups: [
            {
                subtitle: "Listas",
                items: [
                    { key: "empresas_permitidas", label: "Empresas Permitidas", type: "array" },
                    { key: "tabelas_preco_permitidas", label: "Tabelas de Preço Permitidas", type: "array" },
                ],
            },
            {
                subtitle: "Funções",
                items: [
                    { key: "ocultar_exibir_produtos", label: "Ocultar/Exibir Produtos", type: "boolean" }
                ],
            },
            {
                subtitle: "Filtros",
                items: [
                    { key: "filtro_linhaAcessorio", label: "Linha Acessórios", type: "boolean" },
                    { key: "filtro_linhaAco", label: "Linha Aços", type: "boolean" },
                    { key: "filtro_linhaAlmoxarifado", label: "Linha Almoxarifado", type: "boolean" },
                    { key: "filtro_linhaBanhada", label: "Linha Banhadas", type: "boolean" },
                    { key: "filtro_linhaBruto", label: "Linha Brutos", type: "boolean" },
                    { key: "filtro_linhaOuro", label: "Linha Ouros", type: "boolean" },
                    { key: "filtro_linhaPrata", label: "Linha Pratas", type: "boolean" },
                    { key: "filtro_linhaRelogio", label: "Linha Relógios", type: "boolean" },
                    { key: "filtro_empresa", label: "Empresa", type: "boolean" },
                    { key: "filtro_estoque", label: "Estoque", type: "boolean" },
                    { key: "filtro_fabricante", label: "Fabricante", type: "boolean" },
                    { key: "filtro_fornecedor", label: "Fornecedor", type: "boolean" },
                    { key: "filtro_peso", label: "Peso", type: "boolean" },
                    { key: "filtro_genericos", label: "Só Genéricos", type: "boolean" },
                    { key: "filtro_naoGenericos", label: "Só Não Genéricos", type: "boolean" },
                    { key: "filtro_removerDoFiltro", label: "Remover do Filtro", type: "boolean" },
                    { key: "filtro_codigoBruto", label: "Código Bruto", type: "boolean" },
                ],
            },
            {
                subtitle: "Informações",
                items: [
                    { key: "info_aplicacao", label: "Códigos Alternativos", type: "boolean" },
                    { key: "info_categoria", label: "Categoria", type: "boolean" },
                    { key: "info_classe", label: "Classe", type: "boolean" },
                    { key: "info_fabricante", label: "Fabricante", type: "boolean" },
                    { key: "info_fornecedor", label: "Fornecedor", type: "boolean" },
                    { key: "info_refForn", label: "Referência do Fornecedor", type: "boolean" },
                    { key: "info_peso", label: "Peso", type: "boolean" },
                    { key: "info_fcon1", label: "Custo Total", type: "boolean" },
                    { key: "info_fcon2", label: "Custo Bruto", type: "boolean" },
                    { key: "info_labelTabela", label: "Label Tabela de Preço", type: "boolean" },
                    { key: "info_valor", label: "Valor Padrão da Empresa", type: "boolean" },
                    { key: "info_estoques", label: "Estoques", type: "boolean" },
                    { key: "info_detalhes", label: "Detalhes do Produto", type: "boolean" },
                    { key: "info_inputQtdSacola", label: "Input Qtd. Sacola", type: "boolean" },
                    { key: "info_addSacola", label: "Adicionar na Sacola", type: "boolean" },
                ],
            },
            {
                subtitle: "Sacola",
                items: [
                    { key: "sacola_custo", label: "Custo Final", type: "boolean" },
                    { key: "sacola_preco", label: "Preço", type: "boolean" },
                    { key: "sacola_peso", label: "Peso", type: "boolean" },
                    { key: "sacola_estoques", label: "Lista de Estoques", type: "boolean" },
                    { key: "sacola_total", label: "Total da Sacola", type: "boolean" },
                    { key: "sacola_estoquesAbertoPadrao", label: "Estoques Aberto Padrão", type: "boolean" }
                ],
            },
        ],
    },

    // Estoques
    {
        title: "Estoques",
        section: "estoques",
        groups: [
            {
                subtitle: "Acesso",
                items: [
                    { key: "empresas_permitidas", label: "Empresas Permitidas", type: "array" },
                    { key: "subpaginas_permitidas", label: "Subpáginas Permitidas (relatorio, dashboard, conferencia)", type: "array" },
                ],
            },
            {
                subtitle: "Relatório",
                items: [
                    {
                        path: ["relatorio", "filtros"],
                        label: "Filtros do Relatório",
                        type: "booleanMap",
                        labels: {
                            setor: "Setor",
                            regiao: "Região",
                            empresa: "Empresa (código)",
                            nome_empresa: "Nome da empresa",
                            fabricante: "Fabricante",
                        }
                    },
                    {
                        path: ["relatorio", "download_csv"],
                        label: "Download CSV",
                        type: "boolean",
                    }
                ],
            },
        ],
    },

    // Vendas
    {
        title: "Vendas",
        section: "vendas",
        groups: [
            {
                subtitle: "Listas",
                items: [
                    { key: "empresas_permitidas", label: "Empresas Permitidas", type: "array" },
                    { key: "exibirCustoMargem", label: "Custo/Lucro", type: "boolean" },
                    { key: "solicitar_produtos", label: "Solicitar Produtos", type: "boolean" }
                ],
            },
        ],
    },

    // Solicitações de Distribuição
    {
        title: "Solicitações de Distribuição",
        section: "solicitacoes_distribuicao",
        groups: [
            {
                subtitle: "Listas",
                items: [
                    { key: "filtro_solicitante", label: "Filtro Solicitante", type: "boolean" },
                    { key: "alterar_status", label: "Alterar Status", type: "boolean" }
                ],
            },
        ],
    },

    // Giro de Estoque
    {
        title: "Giro de Estoque",
        section: "distribuicoes_vendas",
        groups: [
            {
                subtitle: "Listas",
                items: [
                    { key: "empresas_permitidas", label: "Empresas Permitidas", type: "array" }
                ],
            },
        ],
    },

    // Pedidos
    {
        title: "Pedidos",
        section: "pedidos",
        groups: [
            {
                subtitle: "Listas",
                items: [
                    { key: "somente_pedidos_proprios", label: "Somente Pedidos Próprios", type: "boolean" },
                    { key: "somente_visualizacao", label: "Somente Visualização", type: "boolean" }
                ],
            },
        ],
    }
];